// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"1c496f9d","938":"8de490fa"}[chunkId] + ".css";
};